import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';
import { translate } from '../Services/translation';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }

    render() {
        return (
            <span ref={this.buttonRef}>
                <BuyButton {...this.props} 
                    onClick={(articleNumber, name, price, variant, brand, category, quantityFieldId) => this.props.addToCart(this.buttonRef.current, articleNumber, name, price, variant, brand, category, quantityFieldId)} />
            </span>
        );
    }
}

const mapStateToProps = state => {
    return { }
}

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (buttonDomNode, articleNumber, name, price, variant, brand, category, quantityFieldId) => {
            const nodeIdToShowNotification = buttonDomNode.id = Date.now();
            dispatch(addToCart({ 
                articleNumber,
                name, 
                price, 
                variant, 
                brand, 
                category, 
                quantity: quantityFieldId ? document.getElementById(quantityFieldId)?.value ?? 1 : 1,
                nodeIdToShowNotification,
                notificationMessage: translate('tooltip.addedtocart'),
                hash: Date.now(),
            }));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);